/* Theme-side integrity only: hosted checkout also needs Shopify validation. */
(function () {
  'use strict';
  if (window.__ebPairSync) return;
  window.__ebPairSync = true;
  var config = window.EB_LENS_GUARD || {};
  if (config.internalProduct && window.location.pathname.indexOf('/products/') === 0) {
    window.location.replace(config.redirectUrl || '/collections/kids-prescription-glasses'); return;
  }
  var originalFetch = window.fetch.bind(window), checkoutRunning = false;
  var notice = 'Your frame and lens selection is incomplete or has changed. Please remove the affected pair and select your lenses again, or contact hi@eyebuddykids.com. No additional payment has been taken.';
  var legacy = {
    'Blue Light': [56173391446308], 'Photochromic': [56173380075812],
    'Classic Tint': [56173380174116,67694317437220,67694317469988],
    'Gradient Tint': [56173380272420,67694317502756,67694317535524,67694317568292],
    'Mirrored': [56173380370724,67694317601060,67694317633828,67694317666596,67694317699364,67694317732132,67694317764900],
    'Polarized': [56173380305188,67694317797668,67694317830436],
    '1.61 High-Index': [56173873135908], '1.67 High-Index': [56173392298276], '1.74 High-Index': [56173380436260],
    'Standard Polycarbonate': [56173378339108], 'Advanced Polycarbonate': [56173378568484], 'Complex Polycarbonate': [56173379092772],
    'Standard Trivex': [56173380796708], 'Advanced Trivex': [56173380960548],
    'Progressive': [56173380993316], 'Bifocal': [56173381091620]
  };
  function props(item) { return item.properties || {}; }
  function pair(item) { return props(item)._pair_id; }
  function isLens(item) {
    return /^LENS-/i.test(item.sku || '') || /^lens-flow-/i.test(item.handle || '') ||
      item.handle === 'prism-correction' || /^(lens flow add-on|lens service)$/i.test(item.product_type || '') ||
      !!(props(item).Service && !props(item)['Prescription Type']);
  }
  function isFrame(item) { return !isLens(item) && !!props(item)['Prescription Type']; }
  function requirements(frame) {
    var p = props(frame), tokens = String(p.Lens || '').split(' / '), result = [];
    if (p._eb_required_components != null) {
      var manifest;
      try { manifest = JSON.parse(p._eb_required_components); } catch (e) { throw new Error(notice); }
      if (!Array.isArray(manifest) || manifest.length > 30) throw new Error(notice);
      manifest.forEach(function (entry) {
        if (!entry || !Number.isSafeInteger(entry.id) || entry.id < 1 || entry.quantity !== 1) throw new Error(notice);
        result.push({ ids: [entry.id], quantity: entry.quantity });
      });
    } else {
      tokens.forEach(function (token) { if (legacy[token]) result.push({ ids: legacy[token], quantity: 1 }); });
    }
    var type = p['Prescription Type'];
    if (!/^(Frame Only|Single Vision|Multifocal|Non-Prescription)$/.test(type)) throw new Error(notice);
    if (type === 'Frame Only') {
      if (p.Lens !== 'Frame Only') throw new Error(notice);
    } else {
      if (!p.Lens) throw new Error(notice);
      if (/^(Single Vision|Multifocal)$/.test(type) && !tokens.some(function (t) { return /Polycarbonate|Trivex|High-Index/.test(t) && legacy[t]; })) throw new Error(notice);
      tokens.forEach(function (token) {
        if (legacy[token] && !result.some(function (r) { return r.ids.some(function (id) { return legacy[token].indexOf(id) !== -1; }); })) throw new Error(notice);
      });
      if (type === 'Multifocal' && !tokens.some(function (t) { return t === 'Progressive' || t === 'Bifocal'; })) throw new Error(notice);
      if (type === 'Non-Prescription' && !result.length && p.Lens !== 'Non-Prescription / Clear') throw new Error(notice);
    }
    return result;
  }
  function validate(cart) {
    if (!cart || !Array.isArray(cart.items)) throw new Error('We could not verify your cart. Please try again before checking out.');
    var groups = Object.create(null);
    cart.items.forEach(function (item) {
      var id = pair(item);
      if (!id) { if (isFrame(item) || isLens(item)) throw new Error(notice); return; }
      if (!groups[id]) groups[id] = [];
      groups[id].push(item);
    });
    Object.keys(groups).forEach(function (id) {
      var members = groups[id], frames = members.filter(isFrame);
      if (frames.length !== 1 || members.some(function (i) { return i.quantity !== 1; })) throw new Error(notice);
      var frame = frames[0], components = members.filter(function (i) { return i !== frame; });
      var expected = requirements(frame), used = [];
      expected.forEach(function (required) {
        var index = components.findIndex(function (item, i) {
          return used.indexOf(i) === -1 && required.ids.indexOf(Number(item.variant_id || item.id)) !== -1 &&
            item.quantity === required.quantity && Number(item.original_price == null ? item.price : item.original_price) > 0;
        });
        if (index === -1) throw new Error(notice);
        used.push(index);
      });
      if (props(frame)['Prism Values'] === 'Yes' && !components.some(function (i) { return props(i).Service === 'Prism Correction'; })) throw new Error(notice);
      if (props(frame)['Prescription Type'] === 'Frame Only' && components.some(isLens)) throw new Error(notice);
    });
    return cart;
  }
  function readCart() {
    return originalFetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('We could not verify your cart. Please try again before checking out.'); return r.json(); });
  }
  function showError(error) {
    var box = document.getElementById('eb-pair-integrity-error');
    if (!box) {
      box = document.createElement('div'); box.id = 'eb-pair-integrity-error';
      box.setAttribute('role', 'alert'); box.setAttribute('tabindex', '-1');
      box.style.cssText = 'position:fixed;bottom:18px;left:16px;right:16px;max-width:620px;margin:auto;padding:16px;background:#fff;border:2px solid #b42318;border-radius:8px;color:#7a271a;z-index:2147483647;font:16px/1.5 sans-serif;box-shadow:0 4px 20px #0002';
      document.body.appendChild(box);
    }
    box.textContent = error.message || notice;
    var close = document.createElement('button'); close.type = 'button'; close.textContent = 'Dismiss';
    close.style.cssText = 'display:block;margin-top:8px;text-decoration:underline;background:none;border:0;color:inherit;cursor:pointer';
    close.onclick = function () { box.remove(); }; box.appendChild(close); box.focus();
  }
  function verify() {
    if (window.__ebPairAddPending) return Promise.reject(new Error('Your lenses are still being added. Please wait and try again.'));
    return readCart().then(validate);
  }
  window.EBPairGuard = { validate: validate, verify: verify, showError: showError };
  function checkout(event, url) {
    event.preventDefault(); event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    if (checkoutRunning) return;
    checkoutRunning = true;
    verify().then(function () {
      try { sessionStorage.removeItem('eb-rx-stash'); } catch (e) {}
      window.location.href = url || '/checkout';
    }).catch(function (error) { checkoutRunning = false; showError(error); });
  }
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest && event.target.closest('a[href*="/checkout"], [name="checkout"], #checkout, [data-shopify="payment-button"], .shopify-payment-button, .shopify-cleanslate, .additional-checkout-buttons');
    if (!target && event.target && event.target.closest) {
      var button = event.target.closest('button');
      if (button && /\/checkout/.test(button.getAttribute('@click') || button.getAttribute('x-on:click') || '')) target = button;
    }
    if (target) checkout(event, target.tagName === 'A' ? target.href : '/checkout');
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.querySelector && form.querySelector('[name="checkout"]')) checkout(event, '/checkout');
  }, true);
  if (/^\/cart\/?$/.test(window.location.pathname)) verify().catch(showError);
  function parseBody(body) {
    if (typeof body === 'string') {
      try { return JSON.parse(body); } catch (e) { return Object.fromEntries(new URLSearchParams(body)); }
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) return Object.fromEntries(body.entries());
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return Object.fromEntries(body.entries());
    return null;
  }
  function targetItem(cart, id, line) {
    if (line != null) return cart.items[Number(line) - 1];
    return cart.items.find(function (i) { return i.key === String(id); }) ||
      cart.items.find(function (i) { return String(i.variant_id || i.id) === String(id); });
  }
  var mutationQueue = Promise.resolve();
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;
    if (!/\/cart\/(change|update)(\.js)?(?:\?|$)/.test(url || '') || !init || !init.body) return originalFetch(input, init);
    var body = parseBody(init.body);
    if (!body) return originalFetch(input, init);
    function run() {
      return readCart().then(function (cart) {
        var updates = {}, paired = false, removedPairs = [];
        function apply(item, quantity) {
          if (!item || !pair(item)) return;
          paired = true;
          if (Number(quantity) === 0) {
            if (removedPairs.indexOf(pair(item)) === -1) removedPairs.push(pair(item));
          } else if (Number(quantity) !== 1) throw new Error('Please change an eyewear pair by removing it and configuring it again.');
        }
        if (/\/change/.test(url)) apply(targetItem(cart, body.id, body.line), body.quantity);
        else {
          var changes = body.updates;
          if (Array.isArray(changes)) changes.forEach(function (quantity, index) { var item = cart.items[index]; if (item) { updates[item.key] = quantity; apply(item, quantity); } });
          else if (changes && typeof changes === 'object') Object.keys(changes).forEach(function (id) { var item = targetItem(cart, id); if (item) updates[item.key] = changes[id]; apply(item, changes[id]); });
          else Object.keys(body).forEach(function (key) { var match = /^updates\[(.+)\]$/.exec(key); if (match) { var item = targetItem(cart, match[1]); if (item) updates[item.key] = body[key]; apply(item, body[key]); } });
        }
        if (!paired) return originalFetch(input, init);
        cart.items.forEach(function (item) { if (removedPairs.indexOf(pair(item)) !== -1) updates[item.key] = 0; });
        if (/\/change/.test(url) && Number(body.quantity) === 1) {
          if (body.properties) throw new Error('Please configure prescription details through Select Lenses instead.');
          return originalFetch(input, init);
        }
        return originalFetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates, ...(body.attributes ? { attributes: body.attributes } : {}), ...(body.note != null ? { note: body.note } : {}) }) });
      });
    }
    var task = mutationQueue.then(run);
    mutationQueue = task.catch(function () {});
    return task.catch(function (error) { showError(error); throw error; });
  };
})();
